import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment/moment";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});

function VendorTaxTable({ formState, setFormState, loading }) {
  const classes = useStyles();

  return (
    <div>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          mt={2}
          style={{ width: "0" }}
        >
          <TableContainer className="scrollable">
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4", fontSize: "11" }}>
                  <TableCell sx={{ fontWeight: "bold",color: "#031C30", p: 1 }}>
                    Tax Type
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold",color: "#031C30", p: 1 }}>
                    Description
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}>
                    Exempt From
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}>
                    Exempt To
                  </TableCell>
                  
                </TableRow>
              </TableHead>
              <TableBody>
                {formState?.vendor_tax_detail?.length > 0 &&
                  formState?.vendor_tax_detail?.map((item, index) => {
                    return (
                      <TableRow key={index} sx={{ fontSize: "10" }}>
                        <TableCell sx={{ p: 1 }}>{item.Tax_Type}</TableCell>
                        <TableCell sx={{ p: 1 }}>{item.Description}</TableCell>
                        <TableCell sx={{ p: 1 }}>{item.Exempt_From}</TableCell>
                        <TableCell sx={{ p: 1 }}>{item.Exempt_To}</TableCell>
                       
                      </TableRow>
                    );
                  })}
              </TableBody>
              {/* {loading && <TableSkeleton noOfColumns={9} noOfLines={3} />} */}
            </Table>
            {formState?.vendor_tax_detail?.length === 0   ? <EmptyData /> : ""}
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
}

export default VendorTaxTable;
